module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"shaka-player","commonjs2":"shaka-player","amd":"shaka-player","root":"shaka"}
// module id = 1
// module chunks = 0


// WEBPACK FOOTER //
// dash/external {"commonjs":"shaka-player","commonjs2":"shaka-player","amd":"shaka-player","root":"shaka"}